import { isFeatureEnabledFromConfig } from "./featureFlags";

/** @type {string} Tenant feature flag for Motive ELD/telematics integration. */
export const MOTIVE_INTEGRATION_FEATURE_KEY = "integrations.motive.enabled";

/**
 * Whether Motive integration UI and API usage is enabled for this tenant.
 * Opt-in only: must be explicitly true in resolved feature flags.
 *
 * @param {object} [configs]
 * @returns {boolean}
 */
export function isMotiveIntegrationEnabled(configs = {}) {
  return isFeatureEnabledFromConfig(configs, MOTIVE_INTEGRATION_FEATURE_KEY);
}
